import { QueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const ONE_MINUTE = 60 * 1000

// 4xx'te yeniden deneme yok (kalıcı hata); yalnızca geçici hatalarda (5xx/ağ) bir kez dene.
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 1) {
    return false
  }
  if (error instanceof AxiosError) {
    const status = error.response?.status
    if (status && status >= 400 && status < 500) {
      return false
    }
  }
  return true
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      retry: shouldRetry,
      staleTime: 2 * ONE_MINUTE,
      gcTime: 10 * ONE_MINUTE,
    },
    mutations: { retry: 0 },
  },
})
